import { PortfolioCustomOrderTicketListItem } from "./doPortfolioCustomOrderTicketList";
import Decimal from "decimal.js";
import { createFiniteDecimalFromAnyString } from "@goodfill/decimal";
import { OrderTicketEntity } from "@goodfill/domain-entities";
import { Amount, asAmount } from "@goodfill/domain-properties";
import { orderTicketApiToModel } from "@goodfill/models-typescript";

export interface PortfolioOrderTicket extends OrderTicketEntity {
  alreadyFilled: Amount;
}

export function convertApiToPortfolioOrderTicket(api: PortfolioCustomOrderTicketListItem): PortfolioOrderTicket {
  const alreadyFilled = asAmount(
    api.tradeTickets != null
      ? api.tradeTickets.items.reduce(
          (acc, tradeTicketAmounts) =>
            acc.plus(createFiniteDecimalFromAnyString(tradeTicketAmounts?.amount ?? "0", "tradeTicketAmounts.amount")),
          new Decimal(0),
        )
      : new Decimal(0),
  );

  return {
    ...orderTicketApiToModel(api),
    alreadyFilled,
  };
}
